<!--
 * @Author: your name
 * @Date: 2020-08-27 10:37:46
 * @LastEditTime: 2026-08-14 14:24:17
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares\src\components\system\NodeManage.vue
-->
<template>
  <div class="urgent-content">
    <enfold>
      <div style="margin: 16px;height: calc(100% - 32px);">
        <el-tabs v-model="activeName" style="height: 100%" @tab-click="handleTabs">
          <el-tab-pane :label="$t('csu1')" name="urgentT" style="height: 100%">
            <div class="urgent-c-t">
              <el-table ref="urgentT" :data="urgentTList" style="width: 100%" height="100%" v-loading="loading">
                <el-table-column :label="$t('csu2')">
                  <template slot-scope="scope">
                    <template v-if="isEdit===scope.$index">
                      <el-input size="mini" v-model="name" :placeholder="$t('csu3')"></el-input>
                    </template>
                    <template v-else>{{ scope.row.name }}</template>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('csu4')">
                  <template slot-scope="scope">
                    <template v-if="isEdit===scope.$index">
                      <el-input size="mini" v-model="content" :placeholder="$t('csu3')"></el-input>
                    </template>
                    <template v-else>{{ scope.row.content }}</template>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('schedule.operate')" width="180">
                  <template slot-scope="scope">
                    <el-popconfirm :title="$t('csu5')" @cancel="handleEdit(scope.$index, scope.row,'cancel')" @confirm="handleEdit(scope.$index, scope.row,'confirm')" v-if="isEdit===scope.$index">
                      <el-button size="mini" slot="reference">{{$t('csu6')}}</el-button>
                    </el-popconfirm>
                    <el-button size="mini" :disabled="isEdit!==-1" @click="handleEdit(scope.$index, scope.row,'edit')" v-else>{{$t('csu7')}}</el-button>
                    <el-popconfirm :title="$t('csu8')" @confirm="handleEdit(scope.$index, scope.row,'del')" :disabled="isEdit!==-1">
                      <el-button size="mini" type="danger" slot="reference" style="margin-left: 10px" :disabled="isEdit!==-1">{{$t('csu9')}}</el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="urgent-add">
              <i class="el-icon-plus"></i>
              <el-button type="text" style="font-size:18px" @click="addUrgent">{{$t('csu10')}}</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('csu11')" name="urgentP" style="height: 100%">
            <div class="urgent-c-t">
              <el-table ref="urgentP" :data="urgentPList" style="width: 100%" height="100%" v-loading="loading">
                <el-table-column>
                  <template slot="header">
                    {{$t('csu12')}}
                    <i style="color: #000000; font-size:12px;position: absolute;">{{$t('csu13')}}</i>
                  </template>
                  <template slot-scope="scope">
                    <template v-if="isEdit===scope.$index">
                      <el-input size="mini" v-model="content" :placeholder="$t('csu14')"></el-input>
                    </template>
                    <template v-else>{{ scope.row.content }}</template>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('schedule.operate')" width="180">
                  <template slot-scope="scope">
                    <el-popconfirm :title="$t('csu5')" @cancel="handleEdit(scope.$index, scope.row,'cancel')" @confirm="handleEdit(scope.$index, scope.row,'confirm')" v-if="isEdit===scope.$index">
                      <el-button size="mini" slot="reference">{{$t('csu6')}}</el-button>
                    </el-popconfirm>
                    <el-button size="mini" :disabled="isEdit!==-1" @click="handleEdit(scope.$index, scope.row,'edit')" v-else>{{$t('csu7')}}</el-button>
                    <el-popconfirm :title="$t('csu8')" @confirm="handleEdit(scope.$index, scope.row,'del')" :disabled="isEdit!==-1">
                      <el-button size="mini" type="danger" slot="reference" style="margin-left: 10px" :disabled="isEdit!==-1">{{$t('csu9')}}</el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="urgent-add">
              <i class="el-icon-plus"></i>
              <el-button type="text" style="font-size:18px" @click="addUrgent">{{$t('csu15')}}</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </enfold>
  </div>
</template>

<script>
import enfold from '@/components/basics/Enfold'
import { tableScrollToRow } from "@/assets/scripts/publicFunction";

export default {
  name: "UrgentContent",
  data() {
    return {
      activeName: "urgentT",
      loading: false,
      isEdit: -1,
      name: "",
      content: "",
      urgentPList: [],
      urgentTList: [],
      group_id: this.$cookies.get("group_id")
    }
  },
  created() {
    this.getUrgentPrograms();
    this.getUrgentText();
  },
  methods: {
    handleEdit(index, val, type) {
      // console.log(index, val, type);
      if (type === 'confirm') {
        this.activeName === 'urgentT' && this.addEditUrgentText(val, this.name, this.content);
        this.activeName === 'urgentP' && this.addEditUrgentPrograms(val, this.content);
        setTimeout(() => { this.isEdit = -1; }, 200);
      }

      if (type === 'edit') {
        this.isEdit = index;
        const { name, content } = val;
        this.name = name;
        this.content = content;
      }

      if (type === 'cancel') {
        if (val.isAdd) {
          this.activeName === 'urgentT' && this.urgentTList.pop();
          this.activeName === 'urgentP' && this.urgentPList.pop();
        }
        this.isEdit = -1;
      }

      if (type === 'del') {
        this.delUrgent(val);
      }
    },
    handleTabs() {
      this.isEdit = -1;
      this.getUrgentPrograms();
      this.getUrgentText();
      this.$forceUpdate();
    },
    addUrgent() {
      if (this.activeName === 'urgentT') {
        // console.log('urgentT');
        let urgent = { name: this.$t('csu16'), content: this.$t('csu4'), isAdd: true };
        this.urgentTList.push(urgent);
        this.handleEdit(this.urgentTList.length - 1, urgent, 'edit');
      }
      if (this.activeName === 'urgentP') {
        // console.log('urgentP');
        let urgent = { content: this.$t('csu4'), isAdd: true };
        this.urgentPList.push(urgent);
        this.handleEdit(this.urgentPList.length - 1, urgent, 'edit');
      }
      setTimeout(() => { tableScrollToRow(this.$refs[this.activeName], -1); }, 200);
    },
    async addEditUrgentText(val, name, content) {
      let data = {};
      let url = "";
      if (val.isAdd) {
        data = { name, content, group_id: this.group_id };
        url = "addUrgentText";
      } else {
        data = { id: val.id, name, content };
        url = "editUrgentText";
      }
      await this.$http.post(`/admin/publish/${url}`, data, res => { console.log(res); });
      await this.getUrgentText();
    },
    async addEditUrgentPrograms(val, content) {
      let data = {};
      let url = "";
      if (val.isAdd) {
        data = { content, group_id: this.group_id };
        url = "/admin/publish/addUrgentPrograms";
      } else {
        data = { id: val.id, content };
        url = "/admin/publish/editUrgentPrograms";
      }
      await this.$http.post(url, data, res => { console.log(res); });
      await this.getUrgentPrograms();
    },
    getUrgentText() {
      this.$http.post("/admin/publish/getUrgentText", {}, data => {
        this.urgentTList = data;
      });
    },
    getUrgentPrograms() {
      this.$http.post("/admin/publish/getUrgentPrograms", {
        type: 'list',
        user_id: this.$cookies.get('user_id')
      }, data => {
        this.urgentPList = data;
      });
    },
    async delUrgent(val) {
      const id = val.id;
      if (this.activeName === 'urgentT') {
        await this.$http.post(`/admin/publish/delUrgentText`, { ids: id }, res => {
          console.log(res);
        });
        await this.getUrgentText();
      }
      if (this.activeName === 'urgentP') {
        await this.$http.post(`/admin/publish/delUrgentPrograms`, { ids: id }, res => {
          console.log(res);
        });
        await this.getUrgentPrograms();
      }
    },
  },
  components: {
    enfold
  }
}
</script>

<style lang="scss" scoped>
.urgent-content {
  width: 100%;
  height: 100%;
  .urgent-add {
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
  }
  .urgent-c-t {
    height: calc(100% - 40px);
  }
  /deep/ .el-tabs__content {
    height: calc(100% - 55px);
  }
  /deep/ .el-tabs__item {
    font-size: 18px;
  }
  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 16px;
      color: var(--theme-color-customized-1);
    }
    th:last-child > .cell {
      text-align: center;
    }
  }
}
</style>